import TextSwitcher from "./TextSwitcher";

export default TextSwitcher;
export type { TextSwitcherProps } from "./TextSwitcher.d";
